module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-upgrades--item",
    class: {
      'selected-upgrade': _vm.isActive
    },
    on: {
      "click": _vm.toggleSelectedUpgrade
    }
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--item-image"
  }, [_vm._t("upgrade-image")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-upgrades--item-content"
  }, [_vm._t("upgrade-description")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-upgrades--item-status",
    class: {
      'upgrade-selected-status': _vm.isActive
    }
  }, [(_vm.isActive) ? _c('span', [_vm._v("Selected")]) : _c('span', [_vm._v("Unselected")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2a0696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/UpgradeItem.vue
// module id = 419
// module chunks = 1